import React from 'react';
import { PatientManualRegistrationParams } from '../PatientManualRegistration';
import PatientManualRegistrationHungaryForm, {
	PatientManualRegistrationHungaryFormValues,
} from './PatientManualRegistrationHungaryForm';
import useWorkplacePatient, {
	PatientData,
} from '../../../Hooks/useWorkplacePatient';
import { useLazyUserParentsQuery } from '../../../../../graphql/graphql';
import useFilters from '../../../../Base/Hooks/useFilters';
import useHelpers from '../../../../Base/Hooks/useHelpers';

interface Props {
	workplaceId: string;
	onSuccess?: (params: PatientManualRegistrationParams) => void;
	setIsLoading: (isLoading: boolean) => void;
}

const PatientManualRegistrationHungary: React.FC<Props> = ({
	workplaceId,
	onSuccess,
	setIsLoading,
}) => {
	const { createPatient } = useWorkplacePatient();
	const [getParents] = useLazyUserParentsQuery();
	const { handleDateValue } = useFilters();
	const { handleString } = useHelpers();

	const handleHungaryRegistrationSuccess = async (
		values: PatientManualRegistrationHungaryFormValues,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: values.sendPatientInviteToMeddi,
			patient: {
				salutationBefore: values.salutationBefore ?? undefined,
				salutationAfter: values.salutationAfter ?? undefined,
				firstName: values.firstName,
				lastName: values.lastName,
				address: values.address,
				contactPhoneNumber: values.phoneNumber ?? undefined,
				contactEmail: values.email,
				taj: values.taj,
				birthPlace: values.birthPlace,
				mothersFullname: values.mothersFullname,
				birthDate: handleDateValue(values.birthDate),
				citizenship: handleString(values.citizenship?.value),
				gender: handleString(values.gender?.value),
			},
			legalRepresentative: values.legalRepresentative ?? undefined,
			createdByType: handleString(values.createdByType?.value),
			createdById: values.createdById?.item?.user.id ?? undefined,
		};

		const patient: any = await createPatient(data, workplaceId);
		if (patient) {
			let parentId = null;
			if (data.legalRepresentative) {
				const data = await getParents({
					id: patient.data.userId,
				});
				if (data.data?.user?.parents?.[0]?.id) {
					parentId = data.data?.user?.parents?.[0].id;
				}
			}
			onSuccess?.({
				patientId: patient.data.userId,
				parentId: parentId,
				withInvite: data.sendEmailInvitation,
			});
		}
		setIsLoading(false);
	};

	return (
		<PatientManualRegistrationHungaryForm
			onSuccess={handleHungaryRegistrationSuccess}
		/>
	);
};

export default PatientManualRegistrationHungary;
